
import { API_CALL_STATUS, FORM_STATUS } from "../../reducers/status";
import { getFauluLoanCalculator } from "./index";
import { createSelector } from 'reselect';

export const getFauluCalculator = createSelector(
    getFauluLoanCalculator,
    (state) => state.fauluCalculator
);

export const getLoginDetails = createSelector(
    getFauluLoanCalculator,
    (state) => state.auth
);


export const getDuration = createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator.duration);
export const getFormStatusValid = createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator.formStatus === FORM_STATUS.INVALID);
export const getApiCallStatus= createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator.apiCallStatus);
export const getResultValue= createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator.result);
export const getFauluLoanCalculatorForm= createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator.form);
export const getAccessToken = createSelector(getLoginDetails, (auth) => auth?.loginData);
export const getUgCmbObject = createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator && fauluCalculator.ugCmbObject);
export const getIsExpiredAuth = createSelector(getFauluCalculator, (fauluCalculator) => fauluCalculator && fauluCalculator.isTokenExpired);

const makeGetFormField = fieldName => createSelector(getFauluLoanCalculatorForm, (form) => form[fieldName]);
export const getLoanAmountValue = makeGetFormField('amount');
export const getInterestValue = makeGetFormField('interest');
export const getRepaymentDurationValue = makeGetFormField('repaymentDuration');
export const getDurationValue = makeGetFormField('duration');

const makeGetResultField = fieldName => createSelector(getFauluCalculator, (result) => result[fieldName]);
export const getMonthlyPaymentValue = makeGetResultField('monthlyPayment');
export const getLoanValue = makeGetResultField('loanValue');

export const getIsApiPending = createSelector(
    getFauluCalculator,
    (payload) => payload.apiCallStatus === API_CALL_STATUS.PENDING
);

export const getIsApiSuccess = createSelector(
    getFauluCalculator,
    (payload) => payload.apiCallStatus === API_CALL_STATUS.SUCCESS
);

export const getIsApiFailure = createSelector(
    getFauluCalculator,
    (payload) => payload.apiCallStatus === API_CALL_STATUS.FAILURE
);